module.exports = __webpack_public_path__ + "static/media/master11.ddac89fc.png";